<template>
  <div>
    <div>
      <div v-if="rowData && rowData.items">
        <el-select
          placeholder="请选择"
          popper-class="dropdown-limit-width"
          v-model="getSingleSelect(rowData).model"
          :disabled="getDisabled()"
          @change="bjAnswerBlur($event, rowData)"
        >
          <el-option v-for="(item, idx) in optionItems.items" :label="item.content.text" :key="item.id" :value="item.id">
            <template>
              <el-tooltip
                :disabled="item.content.text < 22"
                class="tooltip-style"
                effect="light"
                :content="item.content.text"
                placement="top"
              >
                <span style="max-width: 350px; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{
                  item.content.text
                }}</span>
              </el-tooltip>
            </template>
          </el-option>
        </el-select>
        <!-- 其他输入框 -->
        <p v-show="isError" style="color: rgb(247, 73, 69)">{{ errorText }}</p>
        <el-input
          v-if="isIsOtherItem()"
          v-model="getOtherModel().model"
          @input="setOtherVal($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
          placeholder="请填写其他选项内容"
        ></el-input>
      </div>
    </div>
  </div>
</template>

<script>
import { itemInitOptions } from '../config/config.js'
import { checkOtherVal, saveArr, getDisabled } from '../public/index.js'

import '../public/style.css'
export default {
  name: 'SingleSelect',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 关联选项
    appendItems: {
      type: Array,
      default: () => {
        return []
      }
    },
    allQuesionList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      errorText: '',
      isError: false,
      oldInputVal: ''
    }
  },
  computed: {
    // 下拉选项
    optionItems() {
      let items = this.rowData.questionDetails.issue.items
      if (this.appendItems.length) {
        items = [...this.appendItems, ...items]
      }
      return {
        items
      }
    },
    // 下拉单选
    getSingleSelect() {
      return function (row) {
        if (row.items.length) {
          return {
            model: row.items[0].optionId
          }
        } else {
          row.items.push(Object.assign({}, itemInitOptions))
          return {
            model: ''
          }
        }
      }
    },
    getOtherModel() {
      return function () {
        const answerFind = this.rowData.items[0]
        const res = (answerFind && answerFind.value) || ''
        return {
          model: res.indexOf('|') !== -1 ? res.split('|')[1] : ''
        }
      }
    }
  },
  methods: {
    bjAnswerBlur(val, row) {
      row.items[0].optionId = val
      row.items[0].value = this.optionItems.items.find(item => {
        return item.id === val
      }).content.text
      this.saveArr()
    },
    isIsOtherItem() {
      const findItem = this.rowData.questionDetails.issue.items.find(item => {
        return item.id === this.rowData.items[0]?.optionId
      })
      return (findItem && findItem.is_other_item === 1) || false
    },
    // 判断是否 选中选项
    hadSelect(optItem) {
      return this.rowData.items.findIndex(r => r.optionId === optItem.id) !== -1
    },
    // 其他选项 输入的input事件
    setOtherVal(val) {
      const item = this.rowData.questionDetails.issue.items.find(i => i.is_other_item === 1)
      const optionId = item.id
      // 从 答案 中 寻找当前的值
      const answerFind = this.rowData.items.find(i => i.optionId === optionId)
      answerFind.value = item.content.text + '|' + val
      // this.saveArr()
    },
    onFocus(e) {
      this.oldInputVal = e.target.value
    },
    onBlur(e) {
      const item = this.rowData.questionDetails.issue.items.find(i => i.is_other_item === 1)
      let res = this.checkOtherVal(e.target.value, item) // 校验
      this.isError = res
      if (res) {
        this.rowData.items.find(i => i.optionId === item.id).value = item.content.text + '|' + this.oldInputVal
      }
      this.saveArr()
    },
    saveArr,
    checkOtherVal,
    getDisabled
  }
}
</script>

<style lang="scss" scoped></style>
